export default {
    zhCN: {
        sales_order: '销售单',
        pack_no: '箱单号',
        pack_status: '箱单状态',
        history: '历史',
        order_confirm: '订单确认',
        order_submit: '订单提交',
        order_cancel: '订单取消',
        order_reviewed_today: '今日已审核订单',
        anji_logistics: '安吉物流',
        fund_review: '资金审核',
        pack: '箱单包装',
        bo_cancel: 'BO取消',
        sale_orders_query: '销售单查询',
        notice_history_query: '通知历史查询',
        is_read: '已读/未读',
        is_read_y: '已读',
        is_read_n: '未读',
        notice: '通知',
        notice_type: '通知类型',
        notice_time: '通知日期',
        notice_msg: '通知消息',
        operation_change_review: '改运审核',
        review_returned: '审核退回',
        bo_cancel_to_review: 'BO取消待审核',
        register_sales: '注册单开票价格修改',
        rebate_results: '返利结果',
        sales_target: '销售目标',
        rebate_payment: '返利支付',
        substandard_dealers: '不达标经销商',
        app_pending_list: '申诉审核',
        substandard_dealers_draft: '不达标数据待提交统计',
        pending_list: '待审核',
        price_pending_list: '价格条款审核',
        rebate_payment_list: 'Payment',
        kpi_target_list: 'KPI Target',
        policy_portfolio_list: 'Policy Portfolio',
        rebate_list: 'Rebate Result',
    },
    enUS: {
        sales_order: 'Sales Order',
        pack_no: 'Pack No',
        pack_status: 'Pack Status',
        history: 'History',
        order_confirm: 'Order Confirm',
        order_submit: 'Order Submit',
        order_cancel: 'Order Cancel',
        order_reviewed_today: 'Order Reviewed Today',
        anji_logistics: 'Anji Logistics',
        fund_review: 'Fund Review',
        pack: 'Pack',
        bo_cancel: 'BO Cancel',
        sale_orders_query: 'Sales Orders Query',
        notice_history_query: 'Notice History Query',
        is_read: 'Read/Unread',
        is_read_y: 'Read',
        is_read_n: 'Unread',
        notice: 'Notice',
        notice_type: 'Notice Type',
        notice_time: 'Notice Time',
        notice_msg: 'Notice Message',
        operation_change_review: 'Operation Change Review',
        review_returned: 'Review Returned',
        bo_cancel_to_review: 'BO Cancel To Review',
        register_sales: 'Registration Order Invoicing Price Modification',
        rebate_results: 'Rebate Results',
        sales_target: 'Sales Target',
        rebate_payment: 'Payment Approval',
        substandard_dealers: 'Non-compliant Dealers',
        app_pending_list: 'Appeal Approval Pending List',
        substandard_dealers_draft: 'Non-compliant Draft',
        pending_list: 'Pending List',
        price_pending_list: 'Price Term Pending List',
        rebate_payment_list: 'Rebate Payment',
        kpi_target_list: 'KPI Target',
        policy_portfolio_list: 'Policy Portfolio',
        rebate_list: 'Rebate',
    },
    deDE: {
        sales_order: 'Verkaufsauftrag',
        pack_no: 'Packnummer',
        pack_status: 'Packstatus',
        history: 'Geschichte',
        order_confirm: 'Bestellung bestätigen',
        order_submit: 'Bestellung abschließen',
        order_cancel: 'Bestellung stornieren',
        order_reviewed_today: 'Heute überprüfte Bestellungen',
        anji_logistics: 'Anji Logistik',
        fund_review: 'Fondsprüfung',
        pack: 'Packen',
        bo_cancel: 'BO-Stornierung',
        sale_orders_query: 'Abfrage der Verkaufsaufträge',
        notice_history_query: 'Abfrage des Verlaufes der Benachrichtigungen',
        is_read: 'Gelesen/Ungelesen',
        is_read_y: 'Gelesen',
        is_read_n: 'Ungelesen',
        notice: 'Notiz',
        notice_type: 'Benachrichtigungstyp',
        notice_time: 'Benachrichtigungszeit',
        notice_msg: 'Benachrichtigungsnachricht',
        operation_change_review: 'Überprüfung der Betriebsänderung',
        review_returned: 'Überprüfung zurückgesandt',
        bo_cancel_to_review: 'BO-Stornierung zur Überprüfung',
    },
    frFR: {
        sales_order: 'Commande de vente',
        pack_no: 'N° de colis',
        pack_status: 'Statut du colis',
        history: 'Historique',
        order_confirm: 'Confirmation de commande',
        order_submit: 'Soumettre la commande',
        order_cancel: 'Annuler la commande',
        order_reviewed_today: 'Commande examinée aujourd\'hui',
        anji_logistics: 'Logistique Anji',
        fund_review: 'Examen des fonds',
        pack: 'Colis',
        bo_cancel: 'Annulation de BO',
        sale_orders_query: 'Recherche de commandes de vente',
        notice_history_query: 'Recherche d\'historique des notifications',
        is_read: 'Lu/Non-lu',
        is_read_y: 'Lu',
        is_read_n: 'Non-lu',
        notice: 'Notification',
        notice_type: 'Type de notification',
        notice_time: 'Heure de notification',
        notice_msg: 'Message de notification',
        operation_change_review: 'Modification de l\'opération d\'examen',
        review_returned: 'Examen retourné',
        bo_cancel_to_review: 'Annulation de BO à réviser',
    },
    nlNL: {
        sales_order: 'Verkooporder',
        pack_no: 'Pakketnummer',
        pack_status: 'Pakketstatus',
        history: 'Geschiedenis',
        order_confirm: 'Order bevestigen',
        order_submit: 'Order indienen',
        order_cancel: 'Order annuleren',
        order_reviewed_today: 'Order beoordeeld vandaag',
        anji_logistics: 'Anji Logistiek',
        fund_review: 'Fondsherziening',
        pack: 'Pakket',
        bo_cancel: 'BO Annuleren',
        sale_orders_query: 'Query Verkooporders',
        notice_history_query: 'Query Kondig Geschiedenis',
        is_read: 'Lezen / Ongelezen',
        is_read_y: 'Gelezen',
        is_read_n: 'Ongelezen',
        notice: 'Kennisgeving',
        notice_type: 'Type Kennisgeving',
        notice_time: 'Kennisgeving Tijd',
        notice_msg: 'Kennisgeving Bericht',
        operation_change_review: 'Wijzigingsbeoordeling',
        review_returned: 'Beoordeling Teruggestuurd',
        bo_cancel_to_review: 'BO Annuleren naar Beoordeling',
    },
    itIT: {
        sales_order: 'Ordine di Vendita',
        pack_no: 'Numero del Pacco',
        pack_status: 'Stato del Pacco',
        history: 'Storia',
        order_confirm: 'Conferma dell’Ordine',
        order_submit: 'Invio dell’Ordine',
        order_cancel: 'Annulla Ordine',
        order_reviewed_today: 'Ordini Recensiti Oggi',
        anji_logistics: 'Logistica Anji',
        fund_review: 'Revisione Fondi',
        pack: 'Pacco Imballaggio',
        bo_cancel: 'Annullamento BO',
        sale_orders_query: 'Query Ordini di Vendita',
        notice_history_query: 'Query Storia delle Notifiche',
        is_read: 'Letto/Non Letto',
        is_read_y: 'Letto',
        is_read_n: 'Non Letto',
        notice: 'Notifica',
        notice_type: 'Tipo di Notifica',
        notice_time: 'Data della Notifica',
        notice_msg: 'Messaggio della Notifica',
        operation_change_review: 'Revisione Cambio Operazione',
        review_returned: 'Recensioni in Ritorno',
        bo_cancel_to_review: 'Annullamento BO in Attesa di Revisione',
    },
};
